import React from "react";
import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  Font,
  Image,
} from "@react-pdf/renderer";
import dayjs from "dayjs";

// Font.register({
//   family: "Manrope",
//   fonts: [
//     {
//       src: "https://fonts.gstatic.com/s/manrope/v15/xn7_tHE41ni1AdIRqXPExKno.ttf",
//       fontWeight: "normal",
//     },
//     {
//       src: "https://fonts.gstatic.com/s/manrope/v15/xn7_tHE41ni1AdIRqYPExKno.ttf",
//       fontWeight: "bold",
//     },
//   ],
// });

Font.register({
  family: "Manrope",
  fonts: [
    { src: "/fonts/Manrope-Regular.ttf" },
    { src: "/fonts/Manrope-Bold.ttf", fontWeight: "bold" },
  ],
});

const styles = StyleSheet.create({
  page: {
    paddingTop: 5,
    paddingBottom: 70,
    fontSize: 10,
    fontFamily: "Manrope",
    color: "#333",
  },
  headerSpace: {
    width: "100%",
    height: 80, // Slightly reduced to avoid taking too much space
    marginBottom: 20,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  header_image: {
    width: "100%", // Not fully filled to look cleaner
    height: "100%",
    // objectFit: "contain",
  },
  contentWrapper: {
    paddingHorizontal: 30,
  },
  mainTitle: {
    fontSize: 16,
    fontWeight: "bold",
    textAlign: "center",
    textTransform: "uppercase",
    marginBottom: 15,
    // borderBottomWidth: 1.5,
    // borderBottomColor: "#000",
    paddingBottom: 3,
  },
  infoSection: {
    flexDirection: "row",
    borderWidth: 1,
    borderColor: "#000",
  },
  infoBox: {
    flex: 1,
    borderRightWidth: 1,
    borderRightColor: "#000",
    padding: 6,
  },
  // Fixed width for the right-side boxes to ensure perfect alignment
  rightBox: {
    width: 120,
    padding: 6,
  },
  label: {
    fontSize: 7,
    color: "#666",
    textTransform: "uppercase",
    marginBottom: 2,
    fontWeight: "bold",
  },
  value: {
    fontSize: 9,
    fontWeight: "bold",
  },
  fullWidthBox: {
    width: "100%",
    borderWidth: 1,
    borderTopWidth: 0,
    borderColor: "#000",
    padding: 6,
    marginBottom: 15,
  },
  tableHeader: {
    flexDirection: "row",
    backgroundColor: "#f2f2f2",
    borderWidth: 1, // Added full border
    borderColor: "#000",
    // borderTopWidth is now included in the '1' above
  },
  tableRow: {
    flexDirection: "row",
    borderLeftWidth: 1,
    borderRightWidth: 1,
    borderBottomWidth: 1,
    borderColor: "#000",
    minHeight: 22,
    alignItems: "center",
  },
  cell: { flex: 1, padding: 4, fontSize: 8 },
  cellRight: {
    flex: 0.8,
    padding: 4,
    fontSize: 8,
    textAlign: "right",
    fontWeight: "bold",
  },
  signatureSection: {
    position: "absolute",
    bottom: 40,
    left: 30,
    right: 30,
    flexDirection: "row",
    justifyContent: "space-between",
  },
  signBox: {
    width: "20%",
    borderTopWidth: 1,
    borderTopColor: "#000",
    paddingTop: 5,
    textAlign: "center",
    fontSize: 8,
    fontWeight: "bold",
  },
  footerPageInfo: {
    position: "absolute",
    bottom: 15,
    left: 30,
    right: 30,
    flexDirection: "row",
    justifyContent: "space-between",
    fontSize: 7,
    color: "grey",
  },
  rowBetween: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 8,
  },

  durationBox: {
    flexDirection: "row",
    justifyContent: "space-around",
    backgroundColor: "#f2f2f2",
    padding: 10,
    marginVertical: 10,
  },

  durationItem: {
    alignItems: "center",
  },

  bold: {
    fontWeight: "bold",
    fontSize: 12,
  },

  sectionTitle: {
    fontWeight: "bold",
    fontSize: 12,
  },

  red: {
    color: "red",
    fontWeight: "bold",
  },

  totalBox: {
    marginTop: 15,
    backgroundColor: "#d4edda",
    padding: 10,
    flexDirection: "row",
    justifyContent: "space-between",
    borderRadius: 5,
  },

  totalText: {
    fontSize: 12,
    fontWeight: "bold",
  },

  totalAmount: {
    fontSize: 14,
    fontWeight: "bold",
    color: "red",
  },
  headerSpace: {
    width: "100%",
    height: 80, // Slightly reduced to avoid taking too much space
    marginBottom: 20,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  header_image: {
    width: "95%", // Not fully filled to look cleaner
    height: "100%",
    objectFit: "contain",
  },
  contentWrapper: {
    paddingHorizontal: 30,
  },
  footer: {
  position: "absolute",
  bottom: 15,
  left: 30,
  right: 30,
  textAlign: "center",
  fontSize: 8,
  color: "grey",
},
});

const GratuityDocument = ({ gratuityPrintData }) => {
  const bondTimeportNoData = JSON.parse(
    localStorage.getItem("BondTimeportNoData") || "[]",
  );
  console.log("bondTimeportNoData:", bondTimeportNoData);
  const headerImage = bondTimeportNoData[0]?.REP_HEADER;
  const footerImage = bondTimeportNoData[0]?.REP_FOOTER;

  console.log("gratuityPrintData:", gratuityPrintData);

  const formatCurrency = (amt) =>
    Number(amt || 0).toLocaleString(undefined, { minimumFractionDigits: 2 });

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <View style={styles.headerSpace} fixed>
          {headerImage && (
            <Image src={headerImage} style={styles.header_image} />
          )}
        </View>
        <View style={styles.contentWrapper}>
          <Text style={styles.mainTitle}>
            Gratuity Calculation For: {gratuityPrintData?.EmployeeID}
          </Text>

          <View style={styles.rowBetween}>
            <Text>Current Basic Salary</Text>
            <Text>{gratuityPrintData?.BasicSalary}</Text>
          </View>

          <View style={styles.rowBetween}>
            <Text>Daily Wage</Text>
            <Text>{gratuityPrintData?.DailyWage}</Text>
          </View>

          {/* Accounts */}
          <View style={styles.rowBetween}>
            <Text>Salary Account</Text>
            <Text>{gratuityPrintData?.SalaryAccount || "-"}</Text>
          </View>

          <View style={styles.rowBetween}>
            <Text>Loan Account</Text>
            <Text>{gratuityPrintData?.LoanAccount}</Text>
          </View>

          {/* Service Duration Box */}
          <View style={styles.durationBox}>
            <View style={styles.durationItem}>
              <Text>Years</Text>
              <Text style={styles.bold}>{gratuityPrintData?.YearsWorked}</Text>
            </View>
            <View style={styles.durationItem}>
              <Text>Months</Text>
              <Text style={styles.bold}>{gratuityPrintData?.MonthsWorked}</Text>
            </View>
            <View style={styles.durationItem}>
              <Text>Days</Text>
              <Text style={styles.bold}>{gratuityPrintData?.DaysWorked}</Text>
            </View>
          </View>

          {/* Gratuity */}
          <View style={styles.rowBetween}>
            <Text style={styles.sectionTitle}>Eligible Gratuity</Text>
            <Text style={styles.red}>
              {formatCurrency(gratuityPrintData?.Gratuity)}
            </Text>
          </View>

          <View style={styles.rowBetween}>
            <Text>Salary Balance</Text>
            <Text style={styles.red}>
              {formatCurrency(gratuityPrintData?.SalaryBalance)}
            </Text>
          </View>

          <View style={styles.rowBetween}>
            <Text>Loans Balance</Text>
            <Text style={styles.red}>
              {formatCurrency(gratuityPrintData?.LoanBalance)}
            </Text>
          </View>

          {/* Total Payable */}
          <View style={styles.totalBox}>
            <Text style={styles.totalText}>Total Payable</Text>
            <Text style={styles.totalAmount}>
              {formatCurrency(
                (gratuityPrintData?.Gratuity || 0) +
                  (gratuityPrintData?.SalaryBalance || 0) -
                  (gratuityPrintData?.LoanBalance || 0),
              )}
            </Text>
          </View>
        </View>
        <View style={styles.footer} fixed>
          {footerImage && (
            <Image src={footerImage} style={styles.header_image} />
          )}
        </View>

      
      </Page>
    </Document>
  );
};

export default GratuityDocument;
